import React from "react";

interface ChipSelectorProps {
  items: {
    id: string;
    label: string;
    secondaryLabel?: string | number;
    style?: React.CSSProperties; // Optional style for individual chips
  }[];
  selected: string | null;
  onChange: (id: string | null) => void;
  className?: string;
}

const ChipSelector: React.FC<ChipSelectorProps> = ({
  items,
  selected,
  onChange,
  className = "",
}) => {
  return (
    <div className={`chip-selector ${className}`}>
      {/* Chips */}
      <div className="flex flex-wrap gap-4 items-center">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onChange(item.id)}
            className={`chip ${
              selected === item.id ? "chip-selected" : "chip-unselected"
            }`}
            style={item.style} // Apply the custom style
          >
            <span style={{ color: item.style?.color || "inherit" }}>
              {item.label}
            </span>
            {item.secondaryLabel ? (
              <span
                style={{
                  color: item.style?.color || "inherit", // Match text color to primary label
                  marginLeft: "0.5rem",
                  fontSize: "0.875rem",
                }}
              >
                ({item.secondaryLabel})
              </span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChipSelector;
